export function hasTenantScopedPermission(
  isTenantSuperAdmin: boolean,
  privileges: string[] | undefined,
  permission: string | undefined
): boolean {
  return isTenantSuperAdmin || Boolean(permission && privileges?.includes(permission));
}
